import React, { useState, useEffect } from 'react';
import './App.css';

// Import images
import devices  from './images/devices.PNG';
import greenCrack  from './images/greenCrack.PNG';
import prr from './images/prr.PNG';
import edd from './images/edd.PNG';
import ogk from './images/ogk.jpg';
import og from './images/og.PNG';
import bubbler from './images/bubbler.PNG';
import gpp from './images/gpp.PNG';
import logo from './images/gpp.PNG';
import heroBg from './images/imm1.PNG';
import fri2 from './images/fri2.PNG';
import prr1 from './images/prr1.PNG';
import raw from './images/raw.PNG';
import muha from './images/muha.PNG';
import ring from './images/ring.PNG';
import bong from './images/bong.PNG'
import zazaa2 from './images/zazaa2.PNG';
import jack from './images/jack.PNG';

import muu from './images/muu.PNG';
import jeee from './images/jeee.PNG';
import drip from './images/drip.PNG';

import pacw from './images/pacw.PNG';
import pacdeal from './images/pacdeal.PNG';
import icecake from './images/icecake.PNG';
import ics from './images/ics.PNG';
import faded from './images/faded.PNG';

import Checkout from './Checkout';

// Product data
const products = [
  {
    id: 1,
    name: "Acapulco Gold",
    type: "Hybrid",
    thc: "Exotics",
    cat: "Exotics-flower",
    price: 180,
    image: icecake
  },
  {
    id: 2,
    name: "Gelato #45",
    type: "Indica",
    thc: "Exotics",
    cat: "Exotics-flower",
    price: 180,
    image: zazaa2
  },
  {
    id: 202,
    name: "Jet fuel",
    type: "Sativa",
    thc: "Exotics",
    cat: "Exotics-flower",
    price: 180,
    image: ics
  },
  {
    id: 3,
    name: "Lemon Cherry Cookies",
    type: "Hybrid",
    thc: "Exotics",
    cat: "Exotics-flower",
    price: 180,
    image: ogk
  },
  {
    id: 4,
    name: "Northern Lights",
    type: "Indica",
    thc: "TopShelf",
    cat: "TopShelf-flower",
    price: 130,
    image: jack
  },
  {
    id: 5,
    name: "Granddaddy Purple",
    type: "Indica",
    thc: "TopShelf",
    cat: "TopShelf-flower",
    price: 130,
    image: gpp
  },
  {
    id: 6,
    name: "Rainbow Sherbert",
    type: "Hybrid",
    thc: "TopShelf",
    cat: "TopShelf-flower",
    price: 130,
    image: og
  },
  {
    id: 7,
    name: "Gorilla Glue",
    type: "Hybrid",
    thc: "Premium",
    cat: "flower",
    price: 100,
    image: bong
  },
  {
    id: 8,
    name: "Bubba Kush",
    type: "Indica",
    thc: "Premium",
    cat: "flower",
    price: 100,
    image: bubbler
  },
  {
    id: 81,
    name: "Lemon Bars",
    type: "Sativa",
    thc: "Premium",
    cat: "flower",
    price: 100,
    image: devices
  },
  {
    id: 82,
    name: "Blackberry Kush",
    type: "Indica",
    thc: "Premium",
    cat: "flower",
    price: 100,
    image: greenCrack
  },
  {
    id: 9,
    name: "10 Indica pre rolls",
    type: "10 premium pre-rolls $80",
    thc: "TopShelf",
    cat: "pre-roll",
    price: 80,
    image: prr
  },
  {
    id: 99,
    name: "5 Indica pre rolls",
    type: "5 premium pre-rolls $50",
    thc: "TopShelf",
    cat: "pre-roll",
    price: 50,
    image: prr1
  },
  {
    id: 10,
    name: "10 Sativa pre rolls",
    type: "10 premium pre-rolls $80",
    thc: "TopShelf",
    cat: "pre-roll",
    price: 80,
    image: prr
  },
  {
    id: 1001,
    name: "5 Sativa pre rolls",
    type: "5 premium pre-rolls $50",
    thc: "TopShelf",
    cat: "pre-roll",
    price: 50,
    image: prr1
  },
  {
    id: 11,
    name: "Peach Ring Gummies",
    type: "$25",
    thc: "100mg",
    cat: "edible",
    price: 25,
    image: ring
  },
  {
    id: 12,
    name: "Gummy worms",
    type: "$25",
    thc: "600mg",
    cat: "edible",
    price: 25,
    image: edd
  },
  {
    id: 102,
    name: "FADED",
    type: "$25",
    thc: "100mg",
    cat: "edible",
    price: 25,
    image: faded
  },
  {
    id: 13,
    name: "Raw Garden",
    type: "$30",
    thc: "Island Girl",
    cat: "Cartridge",
    price: 30,
    image: raw
  },
  {
    id: 14,
    name: "Friendly Farms",
    type: "$30",
    thc: "Chemda WG",
    cat: "Cartridge",
    price: 30,
    image: fri2
  },
  {
    id: 104,
    name: "MUHA MEDS",
    type: "$30",
    thc: "MUHA MEDS - 1G premium THC",
    cat: "Cartridge",
    price: 30,
    image: muha
  },
  {
    id: 161,
    name: "BOUTIQ SWITCH V5 Disposable",
    type: "$60",
    thc: "BOUTIQ SWITCH V5 - 2G (3 in 1)",
    cat: "Disposable",
    price: 60,
    image: jeee
  },
  {
    id: 15,
    name: "Drip Dual Disposable",
    type: "$50",
    thc: "Dual Flavor 2G - 2 IN 1 -Sativa - Indica",
    cat: "Disposable",
    price: 50,
    image: drip
  },
  {
    id: 150,
    name: "PACKWOODS Disposable",
    type: "$50",
    thc: "2G premium THC",
    cat: "Disposable",
    price: 50,
    image: pacw
  },
  {
    id: 151,
    name: " MUHA MEDS Disposable",
    type: "$50",
    thc: "2G premium THC",
    cat: "Disposable",
    price: 50,
    image: muu
  },
  {
    id: 100,
    name: "Two Half Oz Exotic Deal",
    type: "$180",
    thc: " Mix and Match 2 Half Oz exotics flowers",
    cat: "Weekly-Specials",
    twospecial: "twohalf",
    cats: "Weekly-Specialsdisp",
    price: 180,
    image: gpp
  },
  {
    id: 16,
    name: "Two 2G-Disposables Deal",
    type: "$80",
    thc: "Your choice of Two 2G Disposables $80",
    cat: "Weekly-Specials",
    cats: "Weekly-Specialsdisp",
    price: 80,
    image: pacdeal
  },
  {
    id: 17,
    name: "2 Oz Exotics Deal",
    type: "$340",
    thc: "Mix and Match 2 oz exotics flowers",
    cat: "Weekly-Specials",
    catss: "Weekly-SpecialsEx",
    price: 340,
    image: og
  },

];

// Extract unique categories from products Forbidden Fruit
const categories = ["All", ...new Set(products.map(product => product.cat))];

function App() {
  const [cart, setCart] = useState([]);
  const [showCart, setShowCart] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState(false);
  const [ageVerified, setAgeVerified] = useState(false);
  const [activeCategory, setActiveCategory] = useState("All");
  const [filteredProducts, setFilteredProducts] = useState(products);
  const [showCheckout, setShowCheckout] = useState(false);
  const [selectedQuantities, setSelectedQuantities] = useState({});

  useEffect(() => {
    // Check if age was previously verified
    const verified = localStorage.getItem('ageVerified');
    if (verified === 'true') {
      setAgeVerified(true);
    }
  }, []);

  // Filter products when category changes
  useEffect(() => {
    if (activeCategory === "All") {
      setFilteredProducts(products);
    } else {
      setFilteredProducts(products.filter(product => product.cat === activeCategory));
    }
  }, [activeCategory]);

  const addToCart = (product, quantity = 'oz') => {
    let price = product.price;

    // Adjust price based on quantity for flower products
    if (product.cat === 'flower' || 'Exotics-flower') {
      switch (quantity) {
        case 'oz':
          price = 100;
          break;
        case '14g':
          price = 60;
          break;
        case '7g':
          price = 40;
          break;
        default:
          price = 100;
      }
    }
    // Adjust price based on quantity for exotic products
    if (product.cat === 'Exotics-flower') {
      switch (quantity) {
        case 'oz':
          price = 180;
          break;
        case '14g':
          price = 100;
          break;
        case '7g':
          price = 70;
          break;
        case '3.5g':
          price = 50;
          break;
        default:
          price = 180;
      }
    }

    // Adjust price based on quantity for exotic products
    if (product.cat === 'TopShelf-flower') {
      switch (quantity) {
        case 'oz':
          price = 130;
          break;
        case '14g':
          price = 70;
          break;
        case '7g':
          price = 50;
          break;
        case '3.5g':
          price = 40;
          break;
        default:
          price = 130;
      }
    }
    // Adjust price based on quantity for exotic products
    if (product.cat === 'pre-roll') {
      switch (quantity) {
        default:
          price = 80;
      }
    }
    // Adjust price based on quantity for exotic products
    if (product.cat === 'edible') {
      switch (quantity) {
        default:
          price = 25;
      }
    }
    // Adjust price based on quantity for products
    if (product.cat === 'Cartridge') {
      switch (quantity) {
        default:
          price = 30;
      }
    }
    // Adjust price based on quantity for products
    if (product.cats === 'Weekly-Specialsdisp') {
      switch (quantity) {
        default:
          price = 80;
      }
    }
     // Adjust price based on quantity for products
    if (product.twospecial === 'twohalf') {
      switch (quantity) {
        default:
          price = 180;
      }
    }
    // Adjust price based on quantity for products
    if (product.catss === 'Weekly-SpecialsEx') {
      switch (quantity) {
        default:
          price = 340;
      }
    }
    // Adjust price based on quantity for products
    if (product.cat === 'Disposable') {
      switch (quantity) {
        default:
          price = 50;
      }
    }
   

    const cartItem = {
      ...product,
      price,
      quantity: product.cat === 'flower' || 'Exotics-flower' || 'TopShelf-flower' ? quantity : 'each'
    };

    setCart([...cart, cartItem]);
  };

  const removeFromCart = (productId) => {
    setCart(cart.filter(item => item.id !== productId));
  };

  const getCartTotal = () => {
    return cart.reduce((total, item) => total + item.price, 0);
  };

  const handleCheckout = () => {
    setShowCheckout(true);
  };

  const handleOrderComplete = () => {
    setOrderSuccess(true);
    setCart([]);
    setShowCheckout(false);
    setTimeout(() => setOrderSuccess(false), 5000);
  };

  const handleBackToShopping = () => {
    setShowCheckout(false);
  };

  const verifyAge = () => {
    setAgeVerified(true);
    localStorage.setItem('ageVerified', 'true');
  };

  const handleQuantityChange = (productId, quantity) => {
    setSelectedQuantities({
      ...selectedQuantities,
      [productId]: quantity
    });
  };

  const getPriceText = (product) => {
    if (product.cat === 'flower' || 'Exotics-flower' || 'TopShelf-flower') {
      return "Qty:";
    }
    return `$${product.price}`;
  };

  if (!ageVerified) {
    return (
      <div className="age-verification">
        <div className="verification-modal">
          <h2>Age Verification</h2>
          <p>This site contains Cannabis products, you must be 21 years or older to enter</p>
          <div className="verification-buttons">
            <button className="btn-primary" onClick={verifyAge}>I am 21 or older</button>
            <button className="btn-secondary" onClick={() => window.location.href = 'https://www.google.com'}>Exit</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      {showCheckout ? (
        <Checkout
          cart={cart}
          onOrderComplete={handleOrderComplete}
          onBackToShopping={handleBackToShopping}
        />
      ) : (
        <>
          <header className="header">
            <div className="container">
              <div className="logo">
                <a href="#" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit' }}>
                  <img src={logo} alt="Green District" />
                  <span>Green District</span>
                </a>
              </div>
              <nav className="nav">
                <a href="#products">Products</a>
                <a href="#about">About</a>
                <a href="#contact">Contact</a>
              </nav>
              <div className="cart-icon" onClick={() => setShowCart(!showCart)}>
                🛒 ({cart.length})
              </div>
            </div>
          </header>

          {showCart && (
            <div className="cart-sidebar">
              <div className="cart-header">
                <h2>Your Cart</h2>
                <button onClick={() => setShowCart(false)}>×</button>
              </div>
              {cart.length === 0 ? (
                <p>Your cart is empty</p>
              ) : (
                <>
                  <div className="cart-items">
                    {cart.map(item => (
                      <div key={`${item.id}-${item.quantity}`} className="cart-item">
                        <img src={item.image} alt={item.name} />
                        <div className="item-details">
                          <h4>{item.name}</h4>
                          <p>${item.price} ({item.quantity})</p>
                        </div>
                        <button onClick={() => removeFromCart(item.id)}>Remove</button>
                      </div>
                    ))}
                  </div>
                  <div className="cart-total">
                    <div className="btn-primary">
                      <p>Free delivery on orders 50+</p>
                    </div>
                    <h3>Total: ${getCartTotal()}</h3>
                    <button className="btn-primary" onClick={handleCheckout}>Checkout</button>
                  </div>
                </>
              )}
            </div>
          )}

          {orderSuccess && (
            <div className="order-success">
              <p>Order placed successfully! a team member will be in touch to verify your order.</p>
            </div>
          )}

          <section className="hero" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${heroBg})` }}>
            <div className="container">
              <div className="hero-content">
                <h2>Premium Cannabis Delivered to Your Door</h2>
                <p>Fast, discreet, and reliable service in your area</p>
                <a href="#products" className="btn-primary">Shop Now</a>
              </div>
            </div>
          </section>

          <section id="products" className="products">
            <div className="container">
              <h2>Our Products</h2>

              {/* Category Filter */}
              <div className="category-filter">
                <h3>Filter by Category</h3>
                <div className="category-buttons">
                  {categories.map(category => (
                    <button
                      key={category}
                      className={activeCategory === category ? "btn-primary" : "btn-secondary"}
                      onClick={() => setActiveCategory(category)}
                    >
                      {category}
                    </button>
                  ))}
                </div>
              </div>

              <div className="product-grid">
                {filteredProducts.map(product => (
                  <div key={product.id} className="product-card">
                    <img src={product.image} alt={product.name} />
                    <div className="product-info">
                      <h3>{product.name}</h3>
                      <div className="product-details">
                        <span className="type">{product.type}</span>
                        <span> {product.thc}</span>
                      </div>
                      
                      <div className="product-footer">
                        <span className="price">{getPriceText(product)}</span>
                        {product.cat === 'flower' || product.cat === 'Exotics-flower' || product.cat === 'TopShelf-flower' ? (
                          <div className="quantity-selector">
                            <select
                              value={selectedQuantities[product.id] || (product.cat === 'Exotics-flower' ? 'oz' : 'oz')}
                              onChange={(e) => handleQuantityChange(product.id, e.target.value)}
                            >
                              {product.cat === 'Exotics-flower' ? (
                                <>
                                  <option value="oz">Oz($180)</option>
                                  <option value="14g">14g($100)</option>
                                  <option value="7g">7g($70)</option>
                                  <option value="3.5g">3.5g($50)</option>
                                </>
                              ) : product.cat === 'TopShelf-flower' ? (
                                <>
                                  <option value="oz">Oz($130)</option>
                                  <option value="14g">14g($70)</option>
                                  <option value="7g">7g($50)</option>
                                </>
                              )
                                : (
                                  <>
                                    <option value="oz">Oz($100)</option>
                                    <option value="14g">14g($60)</option>
                                    <option value="7g">7g($40)</option>
                                  </>

                                )}
                            </select>
                            <button
                              className="btn-primary"
                              onClick={() => addToCart(product, selectedQuantities[product.id] || (product.cat === 'Exotics-flower' ? 'oz' : 'oz'))}
                            >
                              Add to Cart
                            </button>
                          </div>
                        ) : (
                          <button className="btn-primary" onClick={() => addToCart(product)}>
                            Add to Cart
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section id="about" className="about">
            <div className="container">
              <h2>About Green District</h2>
              <div className="about-content">
                <div className="about-text">
                  <p>Green District is your trusted cannabis delivery service, providing high-quality products with fast and discreet delivery. We carefully curate our selection to ensure you get the best experience possible in full i-71 compliance.</p>
                  <p>Our team of experts is dedicated to helping you find the right products for your needs, whether you're seeking relaxation, creativity, or relief, all within i-71 compliance.</p>
                </div>
                <div className="about-features">
                  <div className="feature">
                    <h3>🚚 Fast Delivery</h3>
                    <p>Get your order in under 60 minutes</p>
                  </div>
                  <div className="feature">
                    <h3>⭐ Quality Products</h3>
                    <p>Lab-tested and carefully selected</p>
                  </div>
                  <div className="feature">
                    <h3>🔒 Discreet Service</h3>
                    <p>Plain packaging for your privacy</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section id="contact" className="contact">
            <div className="container">
              <h2>Contact Us</h2>
              <div className="contact-content">
                <div className="contact-info">
                  <h3>Get in Touch</h3>
                  <p><strong>Phone:</strong> (202) 413-9980</p>
                  <p><strong>Email:</strong> info@greendistrict.com</p>
                  <p><strong>Hours:</strong> 9am - 9pm Daily</p>
                  <p><strong>Address:</strong> 3100 14th street NW, DC</p>
                </div>
                <div className="contact-form">
                  <h3>Send a Message</h3>
                  <form>
                    <input type="text" placeholder="Your Name" />
                    <input type="email" placeholder="Your Email" />
                    <textarea placeholder="Your Message"></textarea>
                    <button type="submit" className="btn-primary">Send Message</button>
                  </form>
                </div>
              </div>
            </div>
          </section>

          <footer className="footer">
            <div className="container">
              <div className="footer-content">
                <div className="footer-section">
                  <h3>Green District</h3>
                  <p>3100 14th St NW, Washington, DC 20010</p>
                  <div className="contact-info">
                    <div className="contact-item">
                      <span className="contact-label">Call:</span>
                      <a href="tel:+12024139980" className="contact-link">(202) 413-9980</a>
                    </div>
                    <div className="contact-item">
                      <span className="contact-label">Text:</span>
                      <a href="sms:+12024139980" className="contact-link">(202) 413-9980</a>
                    </div>
                  </div>
                </div>
                <div className="footer-section">
                  <h4>Quick Links</h4>
                  <a href="#products">Products</a>
                  <a href="#about">About</a>
                  <a href="#contact">Contact</a>
                </div>
                <div className="footer-section">
                  <h4>Legal</h4>
                  <p>You must be 21+. Please consume responsibly.</p>
                  <p>Government-issued ID required for delivery.</p>
                </div>
              </div>
              <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Green District. All rights reserved.</p>
              </div>
            </div>
          </footer>
        </>
      )}
    </div>
  );
}

export default App;